var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainWrapper-innerContent"},[_c('div',{staticClass:"mainWrapper-leftContent mainWrapper-leftContent--fullWidth"},[_c('BreadCrumb',{attrs:{"title":_vm.data.partnerMain.title,"breadcrumbList":_vm.breadcrumbList,"normal":""}}),_c('PartnerArticle',{attrs:{"staticData":_vm.data,"params":_vm.params}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }